import { phpRequest } from "./phpRequest";
import localforage from "localforage";
import { url } from "@/apis/apiSetup";

// 企业设备相关API
const CompanyDeviceApi = {
  // 获取公司列表
  GetCompanyTree: async () => {
    const company_id = await localforage.getItem("userCompanyID");
    return phpRequest.get("/company-tree", {
      company_id: company_id,
      need_device_count: true
    });
  },
  // 获取公司标签
  GetCompanyTag: async company_id => {
    return phpRequest.get("/tag/all", {
      company_id: company_id
    });
  },
  // 获取公司设备列表
  GetDevicesList: data => {
    return phpRequest.get("/devices", data, {
      showLoading: true
    });
  },

  // 获取设备详情
  GetDeviceDetail: device_id => {
    return phpRequest.get(
      "/devices/info",
      { id: device_id },
      {
        showLoading: true
      }
    );
  },

  // 修改设备版本
  UpdateDeviceVersion: (nubisVersion, deviceIds = []) => {
    return phpRequest.put(
      "/devices/nubis-version/update",
      {
        device_ids: deviceIds,
        nubis_version: nubisVersion
      },
      {
        showLoading: true
      }
    );
  },

  // 设备注册
  DeviceRegister: deviceIds => {
    return phpRequest.put(
      "/devices/status/update",
      {
        device_ids: deviceIds,
        status: "registered"
      },
      {
        showLoading: true
      }
    );
  },

  // 指派
  DeviceAssign: (company_ids, deviceIds) => {
    return phpRequest.post(
      "/devices/assign",
      {
        device_ids: deviceIds,
        sub_company_ids: company_ids
      },
      {
        showLoading: true
      }
    );
  },

  // 导出
  Export: data => {
    return phpRequest.get("/devices/download", data, {
      showLoading: true,
    });
  },

  // 上传
  Upload: data => {
    return phpRequest.post("/devices/upload-devices", data, {
      showLoading: true,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  GetStoreTreeListApi: async company_id => {
    const res = await phpRequest.get("/groups/tree", {
      company_id: company_id
    });

    return res;
  },

  // 批量修改设备的下载模板
  DownloadTemplateAPI: async (company_id, downloadType) => {
    const queryParams = {
      company_id: company_id,
      type: downloadType
    };
    const data = await phpRequest.get(
      "/devices/template-excel-download",
      queryParams
    );
    const fileUrl = data.url;
    const link = document.createElement("a");
    link.href = `${url}/${fileUrl}`;
    link.download = "templates.zip";
    link.click();
  },

  // 批量修改设备的上传 /devices/do-action-by-excel
  UpdateUpload: data => {
    return phpRequest.post("/devices/do-action-by-excel", data, {
      showLoading: true,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
export default CompanyDeviceApi;
